module.exports = __webpack_public_path__ + "static/approach@2x-a99b647b4333e0d23901ffc4f2d0c9c1.jpg";